export const carPositionOption = {
    height: 'auto',
    calcHeight: 80,
    tip: false,
    searchShow: true,
    searchMenuSpan: 6,
    labelWidth: 150,
    border: true,
    index: true,
    selection: false,
    viewBtn: false,
    editBtn:false,
    delBtn:false,
    dialogType: 'dialog',
    dialogClickModal: false,
    searchLabelWidth: 100,
    column: [{
            label: "所属代理商",
            prop: "busssinessDeptId",
            type: "select",
            filterable: true,
            addDisplay: false,
            editDisplay: false,
            viewDisplay: false,
            search: true,
            searchMultiple: false,
            searchClearable: true,
            defaultExpandAll: false,
            searchOrder: 1000,
            hide: true,
            dicData: [],
            props: {
                label: "deptName",
                value: "id",
            },
        },
        {
            label: "公司名称",
            prop: "busssinessDeptName",
            type: "select",
            search: false,
            display: true,
            filterable: true,
            span: 24,
            dicData: [],
            props: {
                label: "deptName",
                value: "deptName",
            },
            change: (e) => {},
            rules: [{
                required: true,
                message: "请输入公司名称",
                trigger: "blur"
            }]
        },
        {
            label: "车辆位置",
            prop: "carPosition",
            search: true,
            display: true,
            maxlength:25,
            span: 24,
            rules: [{
                required: true,
                message: "请输入车辆位置",
                trigger: "blur"
            },{ pattern: /^[\u4e00-\u9fa5a-zA-Z0-9]+$/, message: '只能输入数字、汉字、字母', trigger: 'blur' }]
        },
        {
            label: "地址",
            prop: "address",
            slot: true,
            search: false,
            display: false,
        },
        {
            label: "负责人",
            prop: "superintendent",
            slot: true,
            display: true,
            maxlength:25,
            rules:[{ pattern: /^[\u4e00-\u9fa5a-zA-Z0-9]+$/, message: '只能输入数字、汉字、字母', trigger: 'blur' }],
            span: 24,
        },
        {
            label: "创建人",
            prop: "createUserName",
            slot: false,
            display: false
        },
        {
            label: "创建时间",
            prop: "createTime",
            slot: true,
            display: false
        },
        {
            label: "所在区域",
            prop: "region",
            hide: true,
            change: (e) => {},
            type: "cascader",
            search: false,
            dicData: [],
            props: {
                label: "title",
                value: "title",
            },
            span: 24,
        },
        {
            label: "详细地址",
            prop: "carAddress",
            maxlength:50,
            hide: true,
            search: false,
            span: 24,
        },
    ],
}
